import { IDiscountBreakdown } from '@monetize/types/app';
import { formatCurrency } from '@monetize/utils/core';
import { FooterRow } from '../../../../components/Quotes/FooterRow';
import { DISCOUNT_BREAKDOWN_ROWS } from '../../../../constants/quotes';

interface QuoteSequentialDiscountBreakdownProps {
  discountBreakdown: IDiscountBreakdown;
  currency: string;
  variableAmountIndicator: string;
}

export const QuoteSequentialDiscountBreakdown = ({
  discountBreakdown,
  currency,
  variableAmountIndicator,
}: QuoteSequentialDiscountBreakdownProps) => (
  <>
    {DISCOUNT_BREAKDOWN_ROWS.map(({ name, field }) => {
      const amount = discountBreakdown[field];

      if (!amount) {
        return null;
      }
      return (
        <FooterRow
          key={name}
          name={name}
          childrenProps={{ fontWeight: 'normal' }}
          value={
            `(${formatCurrency(amount, { currency })})` +
            variableAmountIndicator
          }
        />
      );
    })}
  </>
);
